import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { register, getMe } from '../services/api';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

export default function Register() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { loginUser }           = useAuth();
  const navigate                = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    setLoading(true);
    try {
      const res = await register(email, password);
      localStorage.setItem('token', res.data.access_token);
      const meRes = await getMe();
      loginUser(res.data.access_token, meRes.data);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-split">

        {/* Left — branding */}
        <div className="auth-left">
          <Link to="/" className="auth-brand">
            <span className="auth-brand-tag mono">Daily AI Puzzles</span>
            <span className="auth-brand-name">Puzzle<span>Forge</span></span>
          </Link>
          <p className="auth-tagline">5 AI-generated puzzles.<br/>Every single day.</p>
          <div className="auth-features">
            <div className="auth-feature">
              <span className="auth-feature-icon">🔤</span>
              <div>
                <strong>WordForge</strong>
                <span>Free daily word puzzle</span>
              </div>
            </div>
            <div className="auth-feature auth-feature-locked">
              <span className="auth-feature-icon">🌍</span>
              <div>
                <strong>GeoForge</strong>
                <span>Guess the country silhouette</span>
              </div>
              <span className="auth-lock mono">Premium</span>
            </div>
            <div className="auth-feature auth-feature-locked">
              <span className="auth-feature-icon">🧠</span>
              <div>
                <strong>TriviaForge</strong>
                <span>5 questions, one topic</span>
              </div>
              <span className="auth-lock mono">Premium</span>
            </div>
            <div className="auth-feature auth-feature-locked">
              <span className="auth-feature-icon">🔢</span>
              <div>
                <strong>MathForge</strong>
                <span>Equation puzzle</span>
              </div>
              <span className="auth-lock mono">Premium</span>
            </div>
            <div className="auth-feature auth-feature-locked">
              <span className="auth-feature-icon">🧩</span>
              <div>
                <strong>LogicForge</strong>
                <span>Grid deduction puzzle</span>
              </div>
              <span className="auth-lock mono">Premium</span>
            </div>
          </div>
        </div>

        {/* Right — form */}
        <div className="auth-right">
          <div className="auth-card">
            <h2 className="auth-title mono">Create account</h2>
            <p className="auth-sub mono">Free forever — premium unlocks all 5 puzzles</p>

            {error && <div className="auth-error mono">{error}</div>}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="auth-field">
                <label className="auth-label mono">Email</label>
                <input
                  className="auth-input mono"
                  type="email" value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                />
              </div>
              <div className="auth-field">
                <label className="auth-label mono">Password</label>
                <input
                  className="auth-input mono"
                  type="password" value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Min. 8 characters"
                  required
                />
              </div>
              <button type="submit" className="auth-submit mono" disabled={loading}>
                {loading ? 'Creating account...' : 'Sign up free →'}
              </button>
            </form>

            <div className="auth-divider"><span className="mono">or</span></div>

            <Link to="/upgrade" className="auth-btn-premium mono">
              ⚡ Get Premium — $4.99/mo
            </Link>

            <p className="auth-switch mono">
              Already have an account? <Link to="/login">Login</Link>
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}
